<div
  class="pill-button"
  [class.pill-button--active]="isActiveSg()"
>
  <div class="pill-button__content">
    <ng-content></ng-content>
  </div>
</div>
